/**
 * @generated SignedSource<<685ddbcf830d92b348328157f3452891>>
 * @relayHash 3eba8b8dd594c6b193a8bdaf7eef6219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8629c42535b42835b781ed29bef51903a792e64e11649ba8def5040051e16284

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8629c42535b42835b781ed29bef51903a792e64e11649ba8def5040051e16284",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider
    }
  }
};

export default node;
